export default "__VITE_ASSET__Xo4rV39a__"